import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { HStack, InputGroup, Stack, VStack } from 'rsuite';

const Brand = props => {
  const {expanded} = props;
  if (!expanded) {
    return (
      <HStack justify="center" className='logo-animated logo-animated-delay-half-seconds rsuite-logo bounce-in'>
        <Logo />
      </HStack>
    );
  }

  return (
    <>
      <VStack spacing={12}>
        <HStack className='logo-animated logo-animated-delay-half-seconds rsuite-logo bounce-in'>
          <Logo />
          <Link to="/">
            <strong style={{ marginLeft: 14 }}>ELITES</strong>
          </Link>
        </HStack>
      </VStack>
    </>
  );

};

export default Brand;
